var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card row cardBemVindo"},[_c('div',{staticClass:"col-12"},[_c('h4',[_vm._v(_vm._s(_vm.$t('Criticidade de OS abertas')))]),_c('canvas',{attrs:{"id":"myChart"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }